/* Dydžių lentelė dialog — SIZE_CHART_HANDOFF.md §7.
   Open/close, body scroll lock, focus trap, focus restore, Escape, ARIA. */
(function () {
  'use strict';

  var root = document.querySelector('[data-nv2-sc]');
  if (!root) return;

  var panel = root.querySelector('[data-nv2-sc-panel]');
  var opener = null;
  var scrollY = 0;

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function focusable() {
    return Array.prototype.filter.call(
      panel.querySelectorAll(FOCUSABLE),
      function (el) { return el.offsetParent !== null || el === panel; }
    );
  }

  function open(trigger) {
    opener = trigger || null;

    /* Lock the page behind the dialog. position:fixed on <body> is the only approach that
       also holds on iOS Safari; the scroll offset is stashed and restored on close so the
       page doesn't jump back to the top. */
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.top = '-' + scrollY + 'px';
    document.body.classList.add('nv2-sc-locked');

    root.hidden = false;
    (panel.querySelector('[data-nv2-sc-close]') || panel).focus();
  }

  function close() {
    root.hidden = true;

    document.body.classList.remove('nv2-sc-locked');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);

    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-nv2-sc-open]');
    if (openBtn) {
      e.preventDefault();
      open(openBtn);
      return;
    }
    if (!root.hidden && e.target.closest('[data-nv2-sc-close]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }

    if (e.key !== 'Tab') return;

    var items = focusable();
    if (!items.length) { e.preventDefault(); panel.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
